import { create } from "zustand"

import type { PresenceEntry } from "@productlane/lib"

interface PresenceState {
	online: Record<string, number>
	setOnline: (entries: PresenceEntry[]) => void
}

export const usePresenceState = create<PresenceState>()((set) => ({
	online: {},
	setOnline: (entries) =>
		set({
			online: Object.fromEntries(
				entries.map(({ userId, lastSeenAt }) => [userId, lastSeenAt]),
			),
		}),
}))

export function useIsMemberOnline(userId: string | undefined): boolean {
	return usePresenceState((state) =>
		userId ? state.online[userId] !== undefined : false,
	)
}

export function useOnlineMemberCount(): number {
	return usePresenceState((state) => Object.keys(state.online).length)
}
